"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassicChannelAccountsPlugin = void 0;
const types_1 = require("../../../../../../stellar-plus/core/pipelines/classic-transaction/types");
const channel_accounts_1 = require("../../soroban-transaction/channel-accounts");
class ClassicChannelAccountsPlugin extends channel_accounts_1.BaseChannelAccountsPlugin {
    constructor(args) {
        super(types_1.ClassicTransactionPipelineType.id, args.channels);
    }
}
exports.ClassicChannelAccountsPlugin = ClassicChannelAccountsPlugin;
